import '../assets/App.css';
import dwarfReading from '../assets/dwarf-reading.png';
import { useState, useEffect } from 'react';
import { useAuth } from '../provider/AuthProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import { RouteNames } from '../components/AppRouter';
import axiosInstance from '../services/axios';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setToken } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const successMessage = location.state?.message;
    
    // Vérifier s'il y a un message dans l'URL (pour les redirections 401)
    // TODO : passer par un state global, le paramètre dans l'url c'est caca
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const messageFromUrl = urlParams.get('message');
        if (messageFromUrl) {
            setError(decodeURIComponent(messageFromUrl));
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, [location.search]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axiosInstance.post('/api/login', {
                username: email,
                password: password
            });

            if (response.data.token) {
                setToken(response.data.token);
                navigate(RouteNames.myComics);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setError('Email et/ou mot de passe incorrect(s)');
            } else {
                setError('Une erreur est survenue lors de la connexion');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="hero-body">
            <div className="container has-text-centered">
                <div className="columns is-vcentered">
                    <div className="column is-5 is-offset-1 box">
                        <h1 className="title is-2">
                            Connexion
                        </h1>
                        {successMessage && (
                            <div className="notification is-success is-light">
                                {successMessage}
                            </div>
                        )}
                        <form onSubmit={handleSubmit}>
                            <div className="field">
                                <div className="control">
                                    <input
                                        className="input is-large"
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                            <div className="field">
                                <div className="control">
                                    <input
                                        className="input is-large"
                                        type="password"
                                        placeholder="Mot de passe"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                            {error && (
                                <div className="notification is-danger is-light">
                                    {error}
                                </div>
                            )}
                            <div className="field">
                                <button
                                    className={`button is-block is-dark is-large is-fullwidth ${loading ? 'is-loading' : ''}`}
                                    type="submit"
                                    disabled={loading}
                                >
                                    Se connecter
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="column is-4 is-offset-1">
                        <figure className="image is-4by3">
                            <img src={dwarfReading} alt="" />
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
